// React
import React from "react";
// Libraries
import pure from "recompose/pure";
import cn from "classnames";
// Custom
import { ICON_NAMES } from "constants/Icons";
import { Icon } from "components";
import styles from "./IconButton.module.scss";

export interface IconButtonProps {
  className?: string;
  colour?: "yellow" | "grey";
  disabled?: boolean;
  iconName: keyof typeof ICON_NAMES;
  id?: string;
  onClick: (event?: React.SyntheticEvent<HTMLButtonElement>) => void;
  size?: "small" | "large";
}
export const IconButton = pure(
  ({ className, colour = "yellow", iconName, size = "large", ...props }: IconButtonProps) => (
    <button
      data-testid="create-button"
      className={cn(
        styles.icon_button,
        {
          [styles[`icon_button--colour__${colour}`]]: true,
          [styles[`icon_button--size__${size}`]]: true,
        },
        className,
      )}
      type="button"
      {...props}
    >
      <Icon
        colour={colour === "grey" ? "black" : "white"}
        name={iconName}
        size={size === "small" ? "small" : "medium"}
      />
    </button>
  ),
);
IconButton.displayName = "IconButton";
